import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Divider } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { colours } from 'utils/theme';
import { Tooltip } from 'components/common';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  .add-icon: hover {
    color: ${props => props.theme.teal} !important;
  }
  .remove-icon: hover {
    color: ${props => props.theme.lightRed} !important;
  }
`;

function IncludeExclude({
  isSelected,
  isExcluded,
  onInclude,
  onExclude,
  onExcludeMouseDown,
}) {
  return (
    <Container>
      <Tooltip title='Include this filter' placement='left'>
        <div onClick={onInclude}>
          <CheckOutlined
            className='add-icon'
            style={{ color: isSelected ? colours.teal : colours.darkGrey }}
          />
        </div>
      </Tooltip>
      <Divider
        type='vertical'
        style={{
          height: 10,
          alignSelf: 'center',
          color: colours.darkGrey,
        }}
      />
      <Tooltip title='Exclude this filter' placement='right'>
        <div onClick={onExclude} onMouseDown={onExcludeMouseDown}>
          <CloseOutlined
            className='remove-icon'
            style={{ color: isExcluded ? colours.lightRed : colours.darkGrey }}
          />
        </div>
      </Tooltip>
    </Container>
  );
}

IncludeExclude.propTypes = {
  isSelected: PropTypes.bool,
  isExcluded: PropTypes.bool,
  onInclude: PropTypes.func,
  onExclude: PropTypes.func,
  onExcludeMouseDown: PropTypes.func,
};

export default IncludeExclude;
